export const ISO_DATE_STR_LENGTH = 10;

export const MIN_DATE = new Date(-8.64e15);
export const MAX_DATE = new Date(8.64e15);

export const MS_PER_DAY = 24 * 60 * 60 * 1000;

export function trimToISODate(dateStr: string): string {
  return dateStr.slice(0, ISO_DATE_STR_LENGTH);
}

export function toLocalDate(dateStr: string): Date {
  const [y, m, d] = parseDateComponents(dateStr);
  return new Date(y, m - 1, d);
}

export function parseDateComponents(dateStr: string): [number, number, number] {
  return dateStr.split('-').map(Number) as [number, number, number];
}

export function isChristmas(dateStr: string): boolean {
  const [_, month, day] = parseDateComponents(dateStr);
  return month === 12 && day === 25;
}

export function daysBetween(date1: Date, date2: Date): number {
  return (date2.getTime() - date1.getTime()) / MS_PER_DAY;
}

export function absDaysBetween(date1: Date, date2: Date): number {
  return Math.abs(daysBetween(date1, date2));
}

export function daysToMs(days: number): number {
  return days * MS_PER_DAY;
}

export function daysAgo(days: number): Date {
  return new Date(Date.now() - daysToMs(days));
}
